<template>
  <span style="color: red;">{{ Object.keys(data).length > 0 ? data : '' }}</span>
</template>

<script type="text/javascript">
export default {
  props: ['data']
}
</script>